<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{titleAction}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="cancel()" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-xl>
            <v-layout wrap>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-flex d-flex lg6 md6 sm12 xs12>
                  <v-switch
                    v-model="localCurso.active"
                    :disabled="!Edit"
                    :label="$t('active')"
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-flex>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-tabs color="primary" fixed-tabs ref="tablanguage">
                  <v-tab
                    :key="index + 100"
                    v-for="(lang, index) in localCurso.name"
                  >{{lang.language.name}}</v-tab>
                  <v-tab-item :key="index + 200" v-for="(lang, index) in localCurso.name">
                    <v-container fluid grid-list-xl>
                      <v-layout wrap>
                        <v-flex d-flex lg12 md12 sm12 xs12>
                          <IgTextField
                            :disabled="!Edit"
                            :rules="[v => !lang.language.required || rules.vacio(v, 'name')]"
                            :status="true"
                            :label="$t('name')"
                            v-model="lang.text"
                          ></IgTextField>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap>
                        <v-flex d-flex lg12 md12 sm12 xs12>
                          <editor
                            v-if="dialog"
                            :api-key="apiKey"
                            v-model="localCurso.curso[index].text"
                            :init="editorInit"
                          ></editor>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-tab-item>
                </v-tabs>
              </v-flex>
              <v-flex d-flex xs12>
                <v-layout row wrap>
                  <v-flex d-flex md4 xs12>
                    <v-autocomplete
                      :disabled="!Edit"
                      :items="teamsList"
                      :rules="[v=>rules.vacio(v, 'team')]"
                      :label="$t('select', {field: $tc('team')})"
                      persistent-hint
                      multiple
                      :chips="true"
                      :deletable-chips="true"
                      v-model="localCurso.teams"
                      @change="searchTeam = ''"
                      :search-input.sync="searchTeam"
                    >
                      <v-list-tile slot="prepend-item" ripple @click="toggleTeams">
                        <v-list-tile-action>
                          <v-icon :color="localCurso.teams.length > 0 ? 'indigo darken-4' : ''">
                            {{
                            iconTeams }}
                          </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>Select All</v-list-tile-title>
                      </v-list-tile>
                      <v-divider slot="prepend-item" class="mt-2" />
                    </v-autocomplete>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-autocomplete
                      :disabled="!Edit"
                      :items="usersList"
                      :rules="[v=>rules.vacio(v, 'user')]"
                      :label="$t('select', {field: $tc('user')})"
                      persistent-hint
                      multiple
                      :chips="true"
                      :deletable-chips="true"
                      v-model="localCurso.users"
                      @change="searchUser = ''"
                      :search-input.sync="searchUser"
                    >
                      <v-list-tile slot="prepend-item" ripple @click="toggleUsers">
                        <v-list-tile-action>
                          <v-icon :color="localCurso.users.length > 0 ? 'indigo darken-4' : ''">
                            {{
                            iconUsers }}
                          </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>Select All</v-list-tile-title>
                      </v-list-tile>
                      <v-divider slot="prepend-item" class="mt-2" />
                    </v-autocomplete>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-autocomplete
                      :disabled="!Edit"
                      :items="tournamentsList"
                      :rules="[v=>rules.vacio(v, 'tournament')]"
                      :label="$t('select', {field: $tc('tournament')})"
                      persistent-hint
                      multiple
                      :chips="true"
                      :deletable-chips="true"
                      v-model="localCurso.tournaments"
                      @change="searchTournament = ''"
                      :search-input.sync="searchTournament"
                    >
                      <v-list-tile slot="prepend-item" ripple @click="toggleTournaments">
                        <v-list-tile-action>
                          <v-icon
                            :color="localCurso.tournaments.length > 0 ? 'indigo darken-4' : ''"
                          >
                            {{
                            iconTournaments }}
                          </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>Select All</v-list-tile-title>
                      </v-list-tile>
                      <v-divider slot="prepend-item" class="mt-2" />
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="reset()"
            color="warning"
            small
            v-if="Edit && externalAction ==='create'"
          >{{$t('reset')}}</v-btn>
          <v-btn
            @click="courseCreate()"
            color="success"
            small
            :loading="loading"
            v-if="externalAction==='create' && can('create', 'course')"
          >{{$t('create')}}</v-btn>
          <v-btn
            @click="courseUpdate()"
            color="secondary"
            small
            :loading="loading"
            v-if="externalAction === 'update' && can('edit', 'course', courseSelected)"
          >{{$t('update')}}</v-btn>
          <v-btn
            @click="courseRemove()"
            color="error"
            small
            :loading="loading"
            v-if="externalAction === 'delete' && can('delete', 'course', courseSelected)"
          >{{$t('delete')}}</v-btn>
          <v-btn @click="cancel()" color="primary" small>{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import rules from '@/helpers/rules'
import queueToast from '@/helpers/queueToast'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'formManager',
  mixins: [rules],
  components: {
    Editor
  },
  props: {
    modal: {
      type: Boolean,
      required: false,
      default: false
    },
    externalAction: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      searchUser: '',
      searchTeam: '',
      searchTournament: '',
      raro: false,
      editorInit: {
        plugins: 'wordcount image imagetools media autoresize',
        toolbar:
          'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | image media',
        automatic_uploads: false,
        min_height: 300,
        resize: true,
        media_live_embeds: true,
        file_picker_types: 'media',
        video_template_callback: function(data) {
          return (
            '<video width="' +
            data.width +
            '" height="' +
            data.height +
            '"' +
            (data.poster ? ' poster="' + data.poster + '"' : '') +
            ' controls="controls">\n' +
            '<source src="' +
            data.source1 +
            '"' +
            (data.source1mime ? ' type="' + data.source1mime + '"' : '') +
            ' />\n' +
            (data.source2
              ? '<source src="' +
                data.source2 +
                '"' +
                (data.source2mime ? ' type="' + data.source2mime + '"' : '') +
                ' />\n'
              : '') +
            '</video>'
          )
        },
        imagetools_toolbar:
          'rotateleft rotateright | flipv fliph | editimage imageoptions',
        images_upload_handler: function(blobInfo, success, failure) {
          function getToken() {
            let result = localStorage.getItem('userToken')
            return result ? result.trim() : ''
          }
          let xhr, formData

          xhr = new XMLHttpRequest()
          xhr.withCredentials = false
          xhr.open('POST', process.env.VUE_APP_API_URL + 'upload/file')
          xhr.setRequestHeader('Authorization', 'Bearer ' + getToken())

          xhr.onload = function() {
            let json

            if (xhr.status !== 200) {
              failure('HTTP Error: ' + xhr.status)
              return
            }

            json = JSON.parse(xhr.responseText)

            if (
              !json ||
              !json.data ||
              !json.data.file ||
              typeof json.data.file.path !== 'string'
            ) {
              failure('Invalid JSON: ' + xhr.responseText)
              return
            }
            console.log(json)

            success(process.env.VUE_APP_IMAGE_URL + json.data.file.filename)
          }

          formData = new FormData()
          formData.append('file', blobInfo.blob(), blobInfo.filename())
          xhr.send(formData)
        },
        file_picker_callback: function(cb, value, meta) {
          if (meta.filetype === 'media') {
            function getToken() {
              let result = localStorage.getItem('userToken')
              return result ? result.trim() : ''
            }
            let input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', 'video/*')
            input.onchange = function() {
              const file = this.files[0]
              let reader = new FileReader()
              reader.readAsDataURL(file)
              reader.onload = function() {
                const id = 'blobid' + new Date().getTime()
                const blobCache = tinymce.activeEditor.editorUpload.blobCache
                const base64 = reader.result.split(',')[1]
                const blobInfo = blobCache.create(id, file, base64)
                blobCache.add(blobInfo)
                let xhr, formData
                xhr = new XMLHttpRequest()
                xhr.withCredentials = false
                xhr.open('POST', process.env.VUE_APP_API_URL + 'upload/file')
                xhr.setRequestHeader('Authorization', 'Bearer ' + getToken())
                xhr.onload = function() {
                  let json
                  if (xhr.status !== 200) {
                    console.log('HTTP Error: ' + xhr.status)
                    return
                  }
                  json = JSON.parse(xhr.responseText)
                  if (
                    !json ||
                    !json.data ||
                    !json.data.file ||
                    typeof json.data.file.path !== 'string'
                  ) {
                    console.log('Invalid JSON: ' + xhr.responseText)
                    return
                  }
                  console.log(json)
                  cb(process.env.VUE_APP_IMAGE_URL + json.data.file.filename, {
                    title: json.data.file.filename
                  })
                }
                formData = new FormData()
                formData.append('file', blobInfo.blob(), blobInfo.filename())
                xhr.send(formData)
              }
            }
            input.click()
          }
        }
      },
      localCurso: {
        name: [],
        curso: [],
        tournaments: [],
        teams: [],
        users: [],
        active: true
      },
      tabs: 0,
      loading: false
    }
  },
  watch: {
    externalAction: function(val) {
      this.editorInit.language = this.$i18n.locale
      this.resolveAction()
    },
    courseSelected: function() {
      this.resolveAction()
    }
  },
  created() {
    this.editorInit.language_url = 'https://infogon.me/tiny-langs/todos.js'
    this.editorInit.language = this.$i18n.locale
  },
  mounted() {
    this.localCurso.name = this.setComplexLanguage()
    this.localCurso.curso = this.setComplexLanguage()
  },
  computed: {
    ...mapState({
      languagesList: state => state.languages.listLanguages,
      teamsList: state => state.teams.listSelectTeams,
      usersList: state => state.users.listSelectUsers,
      courseSelected: state => state.courses.selected,
      courseFile: state => state.courses.file,
      tournamentsList: state => state.tournaments.listSelect
    }),

    apiKey() {
      return process.env.EDITOR_API_KEY
    },
    dialog: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    titleAction() {
      return 'Cursos'
    },
    /**
     * @return {boolean}
     */
    Edit() {
      return this.externalAction !== 'delete'
    },
    likesAllTeams() {
      return this.localCurso.teams.length === this.teamsList.length
    },
    likesSomeTeams() {
      return this.localCurso.teams.length > 0 && !this.likesAllTeams
    },
    iconTeams() {
      if (this.likesAllTeams) return 'check_circle_outline'
      if (this.likesSomeTeams) return 'remove_circle_outline'
      return 'clear_circle_outline'
    },
    likesAllUsers() {
      return this.localCurso.users.length === this.usersList.length
    },
    likesSomeUsers() {
      return this.localCurso.users.length > 0 && !this.likesAllUsers
    },
    iconUsers() {
      if (this.likesAllUsers) return 'check_circle_outline'
      if (this.likesSomeUsers) return 'remove_circle_outline'
      return 'clear_circle_outline'
    },
    likesAllTournaments() {
      return this.localCurso.tournaments.length === this.tournamentsList.length
    },
    likesSomeTournaments() {
      return this.localCurso.tournaments.length > 0 && !this.likesAllTournaments
    },
    iconTournaments() {
      if (this.likesAllTournaments) return 'check_circle_outline'
      if (this.likesSomeTournaments) return 'remove_circle_outline'
      return 'clear_circle_outline'
    }
  },
  methods: {
    ...mapActions({
      create: 'courses/setNew',
      update: 'courses/setUpdate',
      remove: 'courses/setEliminate'
    }),
    fieldLanguage(fieldBase = null) {
      let result = []
      if (!fieldBase) {
        this.languagesList.forEach(item => {
          result.push({
            text: '',
            langId: item._id,
            name: item.name
          })
        })
      } else {
        this.languagesList.forEach(item => {
          let search = fieldBase.find(element => element.langId === item._id)
          if (!search) {
            search = item
          }
          result.push({
            text: search.text || '',
            langId: item._id,
            name: item.name
          })
        })
      }
      return result
    },
    resolveAction() {
      this.tabs = 0
      let me = this
      if (this.externalAction === 'create') {
        this.localCurso = {
          name: this.setComplexLanguage(),
          curso: this.setComplexLanguage(),
          tournaments: [],
          teams: [],
          users: [],
          active: true
        }
      }
      if (
        this.externalAction === 'update' ||
        this.externalAction === 'delete'
      ) {
        if (this.courseSelected) {
          this.localCurso = {
            name: this.setComplexLanguage(this.courseSelected.name),
            curso: this.setComplexLanguage(this.courseSelected.content),
            tournaments: this.courseSelected.tournaments
              ? Array.from(this.courseSelected.tournaments)
              : [],
            teams: this.courseSelected.teams
              ? Array.from(this.courseSelected.teams)
              : [],
            users: this.courseSelected.users
              ? Array.from(this.courseSelected.users)
              : [],
            active: this.courseSelected.active || false
          }
        } else {
          this.localCurso = {
            name: this.setComplexLanguage(),
            curso: this.setComplexLanguage(),
            tournaments: [],
            teams: [],
            users: [],
            active: true
          }
        }
      }
    },
    validateCourse() {
      let message = []
      let error = false
      let spanishName = this.localCurso.name.find(
        item => item.langId === '5bd9f3ee7fa5610014fed21e'
      )
      if (!spanishName || spanishName.text === '') {
        error = true
        message.push(this.$t('error.nameSpanish'))
      }
      let spanishText = this.localCurso.curso.find(
        item => item.langId === '5bd9f3ee7fa5610014fed21e'
      )
      if (!spanishText || spanishText.text === '') {
        error = true
        message.push(this.$t('error.contentSpanish'))
      }
      return {
        message,
        error
      }
    },
    createCourse() {
      let sendCourse = {}
      sendCourse.active = this.localCurso.active
      sendCourse.users = Array.from(this.localCurso.users)
      sendCourse.teams = Array.from(this.localCurso.teams)
      sendCourse.tournaments = Array.from(this.localCurso.tournaments)

      sendCourse.content = this.getComplexLanguage(this.localCurso.curso)
      sendCourse.name = this.getComplexLanguage(this.localCurso.name)
      return sendCourse
    },
    courseCreate() {
      let error = this.validateCourse()
      if (error.error) {
        queueToast(error.message)
        return
      }
      let result = this.createCourse()
      this.loading = true
      this.create(result)
        .then(_ => this.cancel())
        .finally(_ => (this.loading = false))
    },
    courseUpdate() {
      let error = this.validateCourse()
      if (error.error) {
        queueToast(error.message)
        return
      }
      let result = this.createCourse()
      result._id = this.courseSelected._id
      this.loading = true
      this.update(result)
        .then(_ => this.cancel())
        .finally(_ => (this.loading = false))
    },
    courseRemove() {
      this.loading = true
      this.remove(this.courseSelected._id)
        .then(_ => this.cancel())
        .finally(_ => (this.loading = false))
    },
    reset() {
      let me = this
      this.localCurso = {
        name: this.setComplexLanguage(),
        curso: this.setComplexLanguage(),
        tournaments: [],
        teams: [],
        users: [],
        active: true
      }
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    toggleTeams() {
      this.$nextTick(() => {
        if (this.likesAllTeams) {
          this.localCurso.teams = []
        } else {
          this.localCurso.teams = this.teamsList.slice()
        }
      })
    },
    toggleTournaments() {
      this.$nextTick(() => {
        if (this.likesAllTournaments) {
          this.localCurso.tournaments = []
        } else {
          this.localCurso.tournaments = this.tournamentsList.slice()
        }
      })
    },
    toggleUsers() {
      this.$nextTick(() => {
        if (this.likesAllUsers) {
          this.localCurso.users = []
        } else {
          this.localCurso.users = this.usersList.slice()
        }
      })
    }
  }
}
</script>
